<div class="page-wrapper"> <app-bees-header></app-bees-header>
    <div class="stricky-header stricked-menu main-menu">
        <div class="sticky-header__content"></div>
    </div> <!-- Page Header -->
    <section class="page-header">
        <div class="page-header__bg" style="background-image: url(assets/images/backgrounds/page-header-bg.jpg);">
        </div>
        <div class="container">
            <div class="page-header__inner">
                <div class="page-header__img-1"> <img src="assets/images/resources/page-header-img-1.png" alt=""> </div>
                <div class="page-header__shape-1 float-bob-y"> <img src="assets/images/shapes/page-header-shape-1.png"
                        alt=""> </div>
                <h3>Spices</h3>
                <div class="thm-breadcrumb__inner">
                    <ul class="thm-breadcrumb list-unstyled">
                        <li> <a href="index.html">Home</a> </li>
                        <li> <span class="fas fa-angle-right"></span> </li>
                        <li> <a href="services.html">Services</a> </li>
                        <li> <span class="fas fa-angle-right"></span> </li>

                        <li>Spices</li>
                    </ul>
                </div>
            </div>
        </div>
    </section> <!-- Service Details -->
    <section class="service-details">
        <div class="container">
            <div class="row"> <!-- LEFT SIDEBAR -->
                <div class="col-xl-4 col-lg-5">
                    <div class="service-details__sidebar">
                        <div class="service-details__services-box">
                            <h3 class="service-details__services-title">Spices </h3>
                            <ul class="service-details__services-list list-unstyled">
                                <li [class.active]="activeSection === 'pepper'"> <a (click)="goToSection('pepper')">
                                        Pepper <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'cardamom'"> <a (click)="goToSection('cardamom')">
                                        Cardamom <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'cinnamon'"> <a (click)="goToSection('cinnamon')">
                                        Cinnamon <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'clove'"> <a (click)="goToSection('clove')">
                                        Clove <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'nutmeg'"> <a (click)="goToSection('nutmeg')">
                                        Nutmeg <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'leaves'"> <a (click)="goToSection('leaves')">
                                        Bay Leaves
                                        <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'ginger'"> <a (click)="goToSection('ginger')">
                                        Ginger <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'turmeric'"> <a (click)="goToSection('turmeric')">
                                        Turmeric <span class="icon-next"></span> </a> </li>
                                <li [class.active]="activeSection === 'kudampuli'"> <a
                                        (click)="goToSection('kudampuli')">
                                        KudamPuli <span class="icon-next"></span> </a> </li>


                            </ul>
                        </div>
                        <div class="service-details__sidebar-contact">
                            <div class="service-details__sidebar-contact-img">
                                <div class="inner"> <img src="assets/images/services/service-details-sidebar-img.png"
                                        alt=""> </div>
                            </div>
                            <div class="service-details__sidebar-contact-content">
                                <div class="icon"> <span class="icon-phone-call"></span> </div>
                                <h2> <a href="tel:9447117399"> +91 944 7117 399 </a> </h2>
                                <h2 style="color:#fd5523;"> If You Need Any Help <br> Contact With Us </h2>
                            </div>
                        </div>
                    </div>
                </div> <!-- RIGHT CONTENT -->
                <div class="col-xl-8 col-lg-7">
                    <div class="service-details__left"> <!-- PEPPER -->
                        <div *ngIf="activeSection === 'pepper'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-1.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Pepper </h3>
                            <p class="service-details__text-1"> pepper is the most important spice in the world. It is
                                known as the “king of spices” which is the most important spices traded and consumed
                                Internationally. Black pepper ( dried) is available by garbled and ungarbled categories
                                in sealed packets of 100 gram, 200 gram, 500 gram, 1 kg, 5 kg etc. </p>
                        </div> <!-- CARDAMOM -->
                        <div *ngIf="activeSection === 'cardamom'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-2.jpg" alt=""> </div>
                            <h3 class="service-details__title-1"> Cardamom </h3>
                            <p class="service-details__text-1"> Cardamom, often called the “ queen of spices” is a
                                highly aromatic, prized spice used globally in both savoury dishes and sweet desserts
                                for its citrusy, minty and herbal flavour. Green cardamom is popular in teas and
                                pastries while black cardamom is often used for it’s smoky flavour, both are available
                                in sealed packages of 100 gram, 200 gram, 500 gram, 1 kg, 5 kg etc. </p>
                        </div> <!-- CINNAMON -->
                        <div *ngIf="activeSection === 'cinnamon'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-3.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Cinnamon </h3>
                            <p class="service-details__text-1"> Cinnamon is a spice obtained from the inner bark of
                                several tree spices used mainly as an aromatic condiment and flavouring additive in a
                                wide variety of cuisines, in particular sweet and savoury dishes and traditional foods.
                                It is available in sealed packets of 5,10,20,50,100,200 and500 grams 1 kgs. Etc
                            </p>
                        </div>

                        <div *ngIf="activeSection === 'clove'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-4.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Clove </h3>
                            <p class="service-details__text-1"> Clove is one of the most valuable spices that has been
                                used for centuries as food preservative and for many medical purposes . Cloves are the
                                dried flower buds of the spice tree which have been widely used for years not only as a
                                spice but also as a medicine for many ailments. It is available in sealed packets of
                                100, 200; 500 grams and 1 kgs.
                            </p>
                        </div>



                        <div *ngIf="activeSection === 'nutmeg'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-5.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Nutmeg </h3>
                            <p class="service-details__text-1"> Nutmeg is a warm aromatic spice derived from the seed of
                                the spice tree, used in both sweet and savoury dishes including baked goods, sauces and
                                curries.it is available with shell and without shells. Nut mace is is also another yield
                                of nutmeg which is seen separate as an outer coating of the seed which is rich in
                                nutrients like manganese and potassium. It is warm, slightly sweet and pungent,
                                available in 50,100,200.500 grams and 1 kg sealed packets.
                            </p>
                        </div>


                        <div *ngIf="activeSection === 'leaves'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-6.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Bay Leaves
                            </h3>
                            <p class="service-details__text-1"> Bay leaves are aromatic leaves from the laurel
                                tree,Which is widely used as a culinary herb to flavour soups, stews and rice dishes.
                                They are also used for potential health benefits such as assisting digestion. It is
                                available as dried leaves in sealed packets of 100 grams.
                            </p>
                        </div>

                        <div *ngIf="activeSection === 'ginger'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-7.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Ginger
                            </h3>
                            <p class="service-details__text-1">Ginger is widely used as a spice and traditional
                                medicine. It is available in it’s raw form ( green) and in dried from in sealed packets
                                of 500 grams, 1 kgs and5 kgs etc.
                            </p>
                        </div>

                        <div *ngIf="activeSection === 'turmeric'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-8.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">Turmeric
                            </h3>
                            <p class="service-details__text-1">Turmeric is a vibrant yellow spice obtained from the root
                                of the turmeric plant and is widely used in cooking, traditional medicine, and food
                                preparation. It is valued for its rich flavor, natural color, and potential health
                                benefits, including antioxidant and anti-inflammatory properties.
                            </p>
                        </div>


                        <div *ngIf="activeSection === 'kudampuli'" class="product-content">
                            <div class="service-details__img"> <img
                                    src="assets/images/services/service-details-img-9.jpg" alt=""> </div>
                            <h3 class="service-details__title-1">KudamPuli
                            </h3>
                            <p class="service-details__text-1">Kudampuli, also known as Malabar Tamarind, is a
                                traditional souring agent widely used in South Indian cuisine, especially in fish
                                curries. It adds a distinctive tangy flavor to dishes and is valued for its potential
                                digestive and antioxidant benefits.
                            </p>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </section>


    <app-bees-footer></app-bees-footer>
</div>



<div class="lock-popup"
     *ngIf="showPopup">

    <div class="popup-box">

        <h3>

            Enter Access Code

        </h3>

        <div class="pin-box">

            <input #p1
                   maxlength="1"
                   [(ngModel)]="pin1"
                   (input)="moveNext($event,p2)">

            <input #p2
                   maxlength="1"
                   [(ngModel)]="pin2"
                   (input)="moveNext($event,p3)">

            <input #p3
                   maxlength="1"
                   [(ngModel)]="pin3"
                   (input)="moveNext($event,p4)">

            <input #p4
                   maxlength="1"
                   [(ngModel)]="pin4"
                   (input)="moveNext($event)">

        </div>

        <p class="error"
           *ngIf="errorMsg">

            {{errorMsg}}

        </p>

    </div>

</div>

<div *ngIf="!showPopup">

    <!-- EXISTING PAGE -->

</div>